import { EnvironmentInjector, inject, Injectable, runInInjectionContext, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DashboardUserContextService } from '@rma/dashboard/authentication/public/user';
import { map, Observable } from 'rxjs';
import { MetaUserData } from '../domain/fb-events.model';

export interface MetaPixelContext {
  /** User data to use with advanced matching for the meta pixel */
  user?: MetaUserData;
  /** If user is impersonated from RAdmin */
  isImpersonating?: boolean;
}

@Injectable({ providedIn: 'root' })
export class MetaPixelContextService {
  private readonly injector = inject(EnvironmentInjector);
  private readonly usercontextService = inject(DashboardUserContextService);

  private context?: Signal<MetaPixelContext>;

  public getContext(): MetaPixelContext {
    if (!this.context) {
      this.context = runInInjectionContext(this.injector, () => this.loadMetaContext());
    }

    return this.context();
  }

  private loadMetaContext(): Signal<MetaPixelContext> {
    const userData$: Observable<MetaPixelContext> = this.usercontextService.userContext$.pipe(
      map((ctx) => {
        if (!ctx) {
          return {};
        }

        return {
          isImpersonating: ctx.isImpersonating,
          user: {
            external_id: ctx.userId,
            em: ctx.email?.toLowerCase().trim(),
            fn: ctx.firstname?.toLowerCase().trim(),
            ln: ctx.lastname?.toLowerCase().trim(),
          },
        };
      }),
    );
    return toSignal(userData$, { initialValue: {} });
  }
}
